import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner.service';
import { TicketsService } from 'src/app/services/tickets.service';

@Component({
  selector: 'app-ticket-access-page',
  templateUrl: './ticket-access-page.component.html',
  styleUrls: ['./ticket-access-page.component.scss'],
})
export class TicketAccessPageComponent implements OnInit {
  constructor(
    private ticketsService: TicketsService,
    private route: ActivatedRoute,
    private spinnerService: SpinnerService,
    private router: Router
  ) {}

  ticketUid: string = '';
  ticket: any;

  loading: any = true;

  async ngOnInit(): Promise<void> {
    this.loading = true;
    let element = document.querySelector('.tittle-navbar') as HTMLElement;
    element.innerHTML = 'Ticket Access';

    this.route.params.subscribe(async (params: any) => {
      this.ticketUid = params.id;

      (await this.ticketsService.getTicket(this.ticketUid)).subscribe(
        (data: any) => {
          if (data.result) {
            this.ticket = data.result;
          } else {
            alert('getTicket ' + data.message);
          }

          this.loading = false;
        }
      );
    });
  }

  async backToTickets(type: string) {
    this.router.navigate([
      'tickets-access',
      {
        type: type,
      },
    ]);
  }
}
